import { IBaseResponse } from "@nkr/models/base-response";
import { IStrongBoxOpoFilter, IStrongBoxOpoOrderListing } from "@nkr/models/strong-box";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

interface IRetVal {
    list: IStrongBoxOpoOrderListing[],
    loading: boolean,
    error: string,
    refreshData: () => void,
}

function useStrongBoxOpoOrders(filter?: IStrongBoxOpoFilter): IRetVal {
    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<IStrongBoxOpoOrderListing[]>([]);

    const fetchData = async () => {
        setLoading(true);

        let config = {
            url: `${__API__}/strongbox/opo/order/search`,
            data: filter
        };

        try {
            const response: IBaseResponse = await dispatch(AuthActionCreators.apiPost(config));

            if (response && response.data.results && response.data.success) {
                setList(response.data.results);
            } else {
                setError('Unable to load data');
                setList([]);
            }
        } catch (err) {
            setList([]);
            setError(err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        setError('');

        if (filter) fetchData();
    }, [filter]);

    const refreshData = () => {
        if (filter) fetchData();
    }

    return { list, loading, error, refreshData };
}

export default useStrongBoxOpoOrders;
